<section class="ds-modal organ-recovery-confirmation-modal" aria-labelledby="organ_recovery_confirmation_modal_title">
    <div class="organ-recovery-confirmation-modal__header">
        <div class="ds-modal__header organ-recovery-confirmation-modal__header-content">
            <h2 id="organ_recovery_confirmation_modal_title" class="ds-modal__title" data-testid="organRecoveryConfirmationModalHeader">
                Organ Recovery Confirmation
            </h2>
        </div>

        <ds-icon-button
            size="md"
            theme="secondary-gray"
            icon="close"
            data-testid="organRecoveryConfirmationModalCloseButton"
            (buttonClick)="onClose()"
        ></ds-icon-button>
    </div>

    <div class="ds-modal__content organ-recovery-confirmation-modal__content">
        <ds-text size="md" weight="medium" theme="primary" [text]="question"></ds-text>

        <ds-radio-group
            [options]="options"
            [ngModel]="selectedAnswer"
            data-testid="organRecoveryConfirmationModalOptions"
            (change)="onAnswerChange($event)"
        ></ds-radio-group>
    </div>

    <div class="ds-modal__footer ds-modal__footer--full-width organ-recovery-confirmation-modal__footer">
        <ds-button
            label="Cancel"
            size="lg"
            theme="secondary-gray"
            data-testid="organRecoveryConfirmationModalCancelButton"
            (buttonClick)="onCancel()"
        ></ds-button>

        <ds-button
            label="Submit"
            size="lg"
            theme="primary"
            [isDisabled]="isSubmitDisabled"
            data-testid="organRecoveryConfirmationModalSubmitButton"
            (buttonClick)="onSubmit()"
        ></ds-button>
    </div>
</section>
